import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Ticker from 'react-ticker';

export const Header = () => {
  const [mobnav, setMobnav] = useState(true);

  return (
    <>
      <div className="announcement_bar text-white">
        <Ticker offset="0" speed={6}>
          {({ index }) => (
            <span className="text-xs uppercase font-medium">This is the Headline of element #{index}!</span>
          )}
        </Ticker>
      </div>
      <div className="sticky top-0 z-[999] bg-white border-b-[1px] border-gray-100">
        <div className="search flex gap-5 lg:space-y-0 md:justify-between items-center py-3 px-3 mx-auto w-full max-w-8xl lg:px-9 bg-whitw">

          <div className="xl:hidden inline-block">
            <button onClick={() => setMobnav((prevState) => !prevState)} className="flex items-center px-3 py-2 border rounded text-gray-800 border-gray-900">
              <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="./images/logo.svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
            </button>
          </div>
          <div className="mt-0 text-white lg:mr-6">
            <Link to="/"><img src="images/logo.svg" alt="Sightkart" className="w-44" /></Link>
          </div>
          <form className="hidden md:block">
            <div className="relative xl:w-80 md:w-52 w-80">
              <button type="submit" className="absolute right-2.5 bottom-2.5 z-50 cursor-pointer inset-y-2 items-center pl-3"><svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg></button>
              <input type="search" id="default-search" className="focus:outline-none block p-2 pr-10 relative z-20 w-full text-sm text-gray-900 rounded-lg border border-gray-300 dark:bg-white dark:text-gray-800" placeholder="Search..." required />
            </div>
          </form>

          <div className="lg:flex gap-3 lg:justify-between hidden">
            <Link to="/login">
              <p className="w-4 h-4 m-auto">&nbsp;</p>
              <p className="text-[11px] font-light">LOGIN</p>
            </Link>
            <Link to="/signup">
              <p className="w-4 h-4 m-auto">&nbsp;</p>
              <p className="text-[11px] font-light">SIGN UP</p>
            </Link>
            <Link to="/account">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 m-auto">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
              <p className="text-[11px] font-light">MY ACCOUNT</p>
            </Link>
            <Link to="/cart" className="cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 m-auto">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
              <p className="text-[11px] font-light">CART</p>
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-between flex-wrap menu md:h-auto h-0 relative">
          <div className="w-full mx-auto lg:py-3 py-0">
              <nav className={mobnav === true ? "nav fixed lg:relative add_to_cart w-60 lg:w-auto top-0 lg:top-auto h-screen lg:h-auto -left-[114%] lg:left-auto bg-white lg:bg-auto" : "add_to_cart left-0 lg:left-auto fixed lg:relative w-60 lg:w-auto top-0 lg:top-auto h-screen lg:h-auto bg-white lg:bg-auto"}>
                <div className="xl:hidden inline-block">
                  <button onClick={() => setMobnav((prevState) => !prevState)} className="absolute right-2 top-3">
                    <span className=" font-bold cursor-pointer  text-xl text-gray-500 hover:text-gray-700">x</span>
                  </button>
                </div>
                <div className="bg-gray-800 py-3 pl-6 lg:hidden inline-block mb-4 items-center w-full text-white">
                  <Link to="/login"><i class="fa fa-user-circle-o text-2xl mr-1"></i> <span className="text-base relative -top-[4px]">Sign in</span></Link>
                </div>
                <ul class="grid grid-flow-row xl:flex xl:justify-center ul-reset menu">
                  <li><Link to='#'>NEW ARRIVALS</Link></li>
                  <li class='toggleable'>
                    <input type="checkbox" value="selected" id="toggle-one" class="toggle-input" />
                    <label for="toggle-one" class="cursor-pointer">Eyeglasses</label>
                    {/* <Link to='#'>Eyeglasses</Link> */}
                    <div class="mega-menu z-50 h-[500px] xl:h-auto overflow-y-auto shadow-md">
                      <div class="cf">
                        <ul class="ul-reset xl:w-52 w-full">
                          <h3>Men</h3>
                          <li><Link to='#'>Rectangle</Link></li>
                          <li><Link to='#'>Round</Link></li>
                          <li><Link to='#'>Square</Link></li>
                          <li><Link to='#'>Cat-Eye</Link></li>
                          <li><Link to='#'>Wayfarer</Link></li>
                          <li><Link to='#'>Rimless</Link></li>
                        </ul>
                        <ul class="ul-reset xl:w-52 w-full">
                          <h3>Whomen</h3>
                          <li><Link to='#'>Rectangle</Link></li>
                          <li><Link to='#'>Round</Link></li>
                          <li><Link to='#'>Square</Link></li>
                          <li><Link to='#'>Cat-Eye</Link></li>
                          <li><Link to='#'>Wayfarer</Link></li>
                          <li><Link to='#'>Rimless</Link></li>
                        </ul>
                        <ul class="ul-reset xl:w-52 w-full">
                          <h3>Kids</h3>
                          <li><Link to='#'>Rectangle</Link></li>
                          <li><Link to='#'>Round</Link></li>
                          <li><Link to='#'>Square</Link></li>
                          <li><Link to='#'>Cat-Eye</Link></li>
                          <li><Link to='#'>Wayfarer</Link></li>
                          <li><Link to='#'>Rimless</Link></li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li><Link to='#'>SUNGLASSES</Link></li>
                  <li><Link to='#'>ACCESSORIES</Link></li>
                  <li><Link to='/store'>STORE</Link></li>
                  <li><Link to='/about-us'>ABOUT Us</Link></li>
                  <li><Link to='/contact-us'>Contact Us</Link></li>
                </ul>
                <div className="lg:hidden">
                  <h3 className="font-bold pl-2 mt-5 text-gray-800">Follow Us On</h3>
                  <div class="flex gap-4 ml-2 mt-2 text-xl text-cyan-600">
                    <a href="/productdetail"><i class="fa fa-facebook"></i></a>
                    <a href="/productdetail"><i class="fa fa-instagram"></i></a>
                  </div>
                </div>
              </nav>
            
          </div>
        </div>
      </div>

    </>
  )
}